import { Organization, OrganizationRef } from '../../models';
import { FetchContext } from '../fetch-context';
import { responseErrorHandler } from '../response-error-handler';

export const updateNominationOrganization: (
  fetchContext: FetchContext,
  nominationId: number,
  organization: Organization,
  accessToken?: string,
) => Promise<OrganizationRef> = (fetchContext, nominationId, organization, accessToken) =>
  fetch(`${fetchContext.baseUrl}/api/nominations/${nominationId}/organizations`, {
    method: 'PUT',
    body: JSON.stringify(organization),
    headers: {
      Authorization: `Bearer ${accessToken}`,
      'Content-Type': 'application/json',
    },
  })
  .then((response) => responseErrorHandler<OrganizationRef>(fetchContext.errorStore, response, 'update nomination organization'));
